export const GET_VL_ASSET_BEGIN = 'GET_VL_ASSET_BEGIN';
export const GET_VL_ASSET_SUCCESS = 'GET_VL_ASSET_SUCCESS';
export const GET_VL_ASSET_FAIL = 'GET_VL_ASSET_FAIL';
export const GET_VL_ASSET_SUMMARY_BEGIN = 'GET_VL_ASSET_SUMMARY_BEGIN';
export const GET_VL_ASSET_SUMMARY_SUCCESS = 'GET_VL_ASSET_SUMMARY_SUCCESS';
export const GET_VL_ASSET_SUMMARY_FAIL = 'GET_VL_ASSET_SUMMARY_FAIL';
